import { defineStore } from "pinia";
/** Legacy key used by views not yet on ui.store (micro-13-4 bridge). */
export const LEGACY_DARK_MODE_KEY = "darkMode";
function readLegacyDarkMode() {
    if (typeof localStorage === "undefined")
        return false;
    return localStorage.getItem(LEGACY_DARK_MODE_KEY) === "true";
}
/**
 * Global UI state (Pinia template store).
 * Dark mode — single source for Home/Login; legacy localStorage sync until full migration.
 */
export const useUiStore = defineStore("ui", {
    state: () => ({
        isDarkMode: false,
        loading: false,
    }),
    getters: {
        isLoading: (state) => state.loading,
        /** Plan alias: useUiStore().isDark */
        isDark: (state) => state.isDarkMode,
    },
    actions: {
        setDarkMode(value) {
            this.isDarkMode = !!value;
            this.syncLegacyDarkMode();
            this.applyDarkModeClass();
        },
        toggleDarkMode() {
            this.setDarkMode(!this.isDarkMode);
        },
        setLoading(value) {
            this.loading = !!value;
        },
        /** App bootstrap + Login mount: hydrate Pinia + legacy key, apply body class. */
        initTheme() {
            const legacy = readLegacyDarkMode();
            if (legacy && !this.isDarkMode) {
                this.isDarkMode = true;
            }
            this.syncLegacyDarkMode();
            this.applyDarkModeClass();
        },
        syncLegacyDarkMode() {
            if (typeof localStorage === "undefined")
                return;
            localStorage.setItem(LEGACY_DARK_MODE_KEY, String(this.isDarkMode));
        },
        applyDarkModeClass() {
            if (typeof document === "undefined")
                return;
            if (this.isDarkMode) {
                document.body.classList.add("dark-mode");
            }
            else {
                document.body.classList.remove("dark-mode");
            }
        },
    },
    persist: {
        paths: ["isDarkMode"],
    },
});
